import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 2h14M5 22h14M7 2v3.5c0 2 1.5 3.7 3.3 5.1L12 12l1.7-1.4C15.5 9.2 17 7.5 17 5.5V2M7 22v-3.5c0-2 1.5-3.7 3.3-5.1L12 12l1.7 1.4c1.8 1.4 3.3 3.1 3.3 5.1V22"
    }, null, -1)
  ])))
}
export default { render: render }